import {ApiEnumItem} from '../../../types/ApiEnum';

export const getAllTreeKeys = (feature: ApiEnumItem): string[] => {
  const keys: string[] = [];

  const traverseAndCollectKeys = (currentNode: ApiEnumItem) => {
    if (!currentNode) {
      return;
    }
    if (currentNode.value) {
      keys.push(currentNode.value);
    }
    currentNode.children?.forEach(traverseAndCollectKeys);
  };

  traverseAndCollectKeys(feature);
  return keys;
};
